export const config = {
  calculators: [
    {
      name: 'Which Hand Wins Calculator',
      id: 'whw',
      games: [
        {
          name: 'Texas Hold\'em',
          id: 'texas',
          rules: {
            maxPlayers: 8,
            minPlayers: 2,
            numberOfCardsInHand: 2,
            numberOfCardsOnBoard: 5,
            minNumberOfFilledCardsInHandForCosting: 2,
            minNumberOfFilledCardsOnBoardForCosting: 5,
          },
          active: true
        },
        {
          name: 'Omaha',
          id: 'omaha',
          rules: {
            maxPlayers: 8,
            minPlayers: 2,
            numberOfCardsInHand: 4,
            numberOfCardsOnBoard: 5,
            minNumberOfFilledCardsInHandForCosting: 4,
            minNumberOfFilledCardsOnBoardForCosting: 5,
          }
        }
      ]
    },
    {
      name: 'Poker Odds Calculator',
      id: 'poc',
      games: [
        {
          name: 'Texas Holdem',
          id: 'texas',
          rules: {
            maxPlayers: 7,
            minPlayers: 2,
            numberOfCardsInHand: 2,
            numberOfCardsOnBoard: 4,
            minNumberOfFilledCardsInHandForCosting: 2,
            minNumberOfFilledCardsOnBoardForCosting: 0,
          },
          active: true,
        },
        {
          name: 'Texas Holdem Hi/Lo',
          id: 'texasHL',
          rules: {
            maxPlayers: 7,
            minPlayers: 2,
            numberOfCardsInHand: 2,
            numberOfCardsOnBoard: 4,
            minNumberOfFilledCardsInHandForCosting: 2,
            minNumberOfFilledCardsOnBoardForCosting: 0,
            hiLo: true,
          }
        },
        {
          name: 'Omaha',
          id: 'omaha',
          rules: {
            maxPlayers: 7,
            minPlayers: 2,
            numberOfCardsInHand: 4,
            numberOfCardsOnBoard: 4,
            minNumberOfFilledCardsInHandForCosting: 4,
            minNumberOfFilledCardsOnBoardForCosting: 0,
          }
        },
        {
          name: 'Omaha Hi/Lo',
          id: 'omahaHL',
          rules: {
            maxPlayers: 7,
            minPlayers: 2,
            numberOfCardsInHand: 4,
            numberOfCardsOnBoard: 4,
            minNumberOfFilledCardsInHandForCosting: 4,
            minNumberOfFilledCardsOnBoardForCosting: 0,
            hiLo: true,
          }
        },
        {
          name: '7-Card Stud',
          id: 'stud',
          rules: {
            maxPlayers: 5,
            minPlayers: 2,
            numberOfCardsInHand: 6,
            numberOfCardsOnBoard: 0,
            minNumberOfFilledCardsInHandForCosting: 3,
            minNumberOfFilledCardsOnBoardForCosting: 0,
            noCommunityCards: true,
          }
        },
        {
          name: '7-Card Stud Hi/Lo',
          id: 'studHL',
          rules: {
            maxPlayers: 5,
            minPlayers: 2,
            numberOfCardsInHand: 6,
            numberOfCardsOnBoard: 0,
            minNumberOfFilledCardsInHandForCosting: 3,
            minNumberOfFilledCardsOnBoardForCosting: 0,
            noCommunityCards: true,
            hiLo: true,
          }
        },
        {
          name: '7-Card Stud Hi/Lo No Qualifier',
          id: 'studHLNQ',
          rules: {
            maxPlayers: 5,
            minPlayers: 2,
            numberOfCardsInHand: 6,
            numberOfCardsOnBoard: 0,
            minNumberOfFilledCardsInHandForCosting: 3,
            minNumberOfFilledCardsOnBoardForCosting: 0,
            noCommunityCards: true,
            hiLo: true,
          }
        },
        {
          name: 'Razz',
          id: 'razz',
          rules: {
            maxPlayers: 5,
            minPlayers: 2,
            numberOfCardsInHand: 6,
            numberOfCardsOnBoard: 0,
            minNumberOfFilledCardsInHandForCosting: 3,
            minNumberOfFilledCardsOnBoardForCosting: 0,
            noCommunityCards: true,
          }
        },
      ]
    }
  ]
};